"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTRSchema = void 0;
const yup_1 = require("yup");
const HierarchyGroup = (0, yup_1.object)({
    ARN: (0, yup_1.string)().required(),
    GroupName: (0, yup_1.string)().required()
});
exports.CTRSchema = (0, yup_1.object)({
    ID: (0, yup_1.string)().required(),
    AWSAccountId: (0, yup_1.string)().required(),
    AWSContactTraceRecordFormatVersion: (0, yup_1.string)().required(),
    Agent: (0, yup_1.object)({
        ARN: (0, yup_1.string)().required(),
        AfterContactWorkDuration: (0, yup_1.number)().required(),
        AfterContactWorkStartTimestamp: (0, yup_1.string)().nullable(),
        AfterContactWorkEndTimestamp: (0, yup_1.string)().nullable(),
        AgentInteractionDuration: (0, yup_1.number)().required(),
        ConnectedToAgentTimestamp: (0, yup_1.string)().nullable(),
        CustomerHoldDuration: (0, yup_1.number)().required(),
        HierarchyGroups: (0, yup_1.object)({
            Level1: HierarchyGroup.nullable().default(null),
            Level2: HierarchyGroup.nullable().default(null),
            Level3: HierarchyGroup.nullable().default(null),
            Level4: HierarchyGroup.nullable().default(null),
            Level5: HierarchyGroup.nullable().default(null),
        }).nullable().default(null),
        LongestHoldDuration: (0, yup_1.number)().required(),
        NumberOfHolds: (0, yup_1.number)().required(),
        RoutingProfile: (0, yup_1.object)({
            ARN: (0, yup_1.string)().required(),
            Name: (0, yup_1.string)().required()
        }),
        Username: (0, yup_1.string)().required(),
    }).nullable().default(null),
    AgentConnectionAttempts: (0, yup_1.number)().required(),
    Attributes: (0, yup_1.mixed)(),
    Channel: (0, yup_1.string)().required(),
    ConnectedToSystemTimestamp: (0, yup_1.string)().nullable(),
    ContactDetails: (0, yup_1.mixed)().notRequired(),
    ContactId: (0, yup_1.string)().required(),
    CustomerEndpoint: (0, yup_1.object)({
        Address: (0, yup_1.string)().required(),
        Type: (0, yup_1.string)().required()
    }).required(),
    DisconnectTimestamp: (0, yup_1.string)().required(),
    DisconnectReason: (0, yup_1.string)().notRequired(),
    InitialContactId: (0, yup_1.string)().nullable().default(null),
    InitiationMethod: (0, yup_1.string)().required(),
    InitiationTimestamp: (0, yup_1.string)().required(),
    InstanceARN: (0, yup_1.string)().required(),
    LastUpdateTimestamp: (0, yup_1.string)().required(),
    MediaStreams: (0, yup_1.array)((0, yup_1.object)()),
    NextContactId: (0, yup_1.string)().nullable().default(null),
    PreviousContactId: (0, yup_1.string)().nullable().default(null),
    Queue: (0, yup_1.object)({
        ARN: (0, yup_1.string)().required(),
        DequeueTimestamp: (0, yup_1.string)().nullable(),
        Duration: (0, yup_1.number)().required(),
        EnqueueTimestamp: (0, yup_1.string)().nullable(),
        Name: (0, yup_1.string)().required(),
    }).nullable().default(null),
    Recording: (0, yup_1.object)({
        DeletionReason: (0, yup_1.string)().nullable(),
        Location: (0, yup_1.string)().required(),
        Status: (0, yup_1.string)().required(),
        Type: (0, yup_1.string)().required()
    }).nullable().default(null),
    Recordings: (0, yup_1.array)((0, yup_1.object)()).nullable().default(null),
    References: (0, yup_1.array)((0, yup_1.object)({
        Name: (0, yup_1.string)().required(),
        Type: (0, yup_1.string)().required(),
        Value: (0, yup_1.string)().required()
    })).nullable().default(null),
    SystemEndpoint: (0, yup_1.object)({
        Address: (0, yup_1.string)().required(),
        Type: (0, yup_1.string)().required()
    }),
    TransferCompletedTimestamp: (0, yup_1.string)().nullable().notRequired(),
    TransferredToEndpoint: (0, yup_1.object)({
        Address: (0, yup_1.string)().notRequired(),
        Type: (0, yup_1.string)().required()
    }).nullable().default(null),
});
